module.exports = __webpack_public_path__ + "img/plus.9a23939e.svg";